export default "__VITE_ASSET__804bcae1__"